import { motion } from "framer-motion";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_PHONE_DISPLAY, WHATSAPP_URL } from "@/lib/constants";

export default function Cta() {
  return (
    <section className="grain relative overflow-hidden bg-[#12263a] py-20 sm:py-28" data-testid="cta-section">
      <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-[#14b8a6]/10 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-serif text-3xl font-semibold text-white sm:text-5xl" data-testid="cta-title">
            ¿Listo para <span className="italic text-[#14b8a6]">empezar</span>?
          </h2>
          <p className="mt-5 max-w-md text-base text-white/70 sm:text-lg" data-testid="cta-text">
            Descarga la app o escríbenos directamente al{" "}
            <span className="font-bold text-white">{WHATSAPP_PHONE_DISPLAY}</span>. Te respondemos en minutos.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-button"
            className="mt-8 inline-flex items-center gap-2.5 rounded-2xl bg-[#25D366] px-7 py-4 text-sm font-extrabold text-[#06281a] transition-transform duration-200 hover:scale-[1.04] active:scale-95"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Hablar por WhatsApp
          </a>
        </motion.div>

        <motion.a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="group block rounded-[2rem] border border-white/10 bg-white/5 p-8 backdrop-blur-sm transition-colors duration-300 hover:border-[#25D366]/50 sm:p-10"
          data-testid="cta-phone-card"
        >
          <span className="inline-flex items-center gap-2 rounded-full bg-[#25D366]/15 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-[#25D366]">
            <WhatsAppIcon className="h-3.5 w-3.5" />
            WhatsApp directo
          </span>
          <span className="mt-6 block font-serif text-4xl font-semibold text-white transition-colors duration-300 group-hover:text-[#25D366] sm:text-5xl">
            {WHATSAPP_PHONE_DISPLAY}
          </span>
          <span className="mt-3 block text-sm text-white/60">
            Sin registros, sin formularios y sin pagos. <span className="text-[#f59e0b]">Te respondemos en minutos.</span>
          </span>
        </motion.a>
      </div>
    </section>
  );
}
